const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Inbound Configuration',
  description: 'Return and Vendor movement flow are enabled on setting it as true',
  sortOrder: 1,
  name: 'inboundConfigurationSettings',
  documentKey: 'inbound_configuration_settings',
  values: {
    return_flow: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Return Flow',
      documentKey: 'return_flow',
    },
    vendor_flow: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Vendor Flow',
      documentKey: 'vendor_flow',
    },
  },
};
